import React from 'react';
import { Icons } from '../../payloadNew/Icons';

// Steps factory for the PayloadNew tour. Receives the i18n `t` function and
// returns an array of step objects. body accepts strings or React nodes.
// Steps whose target isn't present in the DOM are skipped automatically.

const HelpIcon = () => (
	<span className='ds-tour-inline-icon' aria-hidden='true'>
		<Icons.help />
	</span>
);

const getPayloadNewSteps = (t) => [
	{
		target: '.pn-rail',
		title: t('tour.payloadNew.rail.title'),
		body: t('tour.payloadNew.rail.body'),
	},
	{
		target: '#pn-identity',
		title: t('tour.payloadNew.identity.title'),
		body: t('tour.payloadNew.identity.body'),
	},
	{
		target: '#pn-payload',
		title: t('tour.payloadNew.payload.title'),
		body: t('tour.payloadNew.payload.body'),
	},
	{
		target: '#pn-status',
		title: t('tour.payloadNew.status.title'),
		body: t('tour.payloadNew.status.body'),
	},
	{
		target: '#pn-location',
		title: t('tour.payloadNew.location.title'),
		body: t('tour.payloadNew.location.body'),
	},
	{
		target: '#pn-score',
		title: t('tour.payloadNew.score.title'),
		body: (
			<>
				{t('tour.payloadNew.score.bodyBefore')} <HelpIcon /> {t('tour.payloadNew.score.bodyAfter')}
			</>
		),
	},
	{
		target: '#pn-insights',
		title: t('tour.payloadNew.insights.title'),
		body: t('tour.payloadNew.insights.body'),
	},
	{
		target: '#pn-content',
		title: t('tour.payloadNew.content.title'),
		body: t('tour.payloadNew.content.body'),
	},
	{
		target: '.pn-pdf-link--rail',
		title: t('tour.payloadNew.pdf.title'),
		body: t('tour.payloadNew.pdf.body'),
	},
	{
		target: '.pn-rail-share',
		title: t('tour.payloadNew.share.title'),
		body: t('tour.payloadNew.share.body'),
	},
];

export default getPayloadNewSteps;
